<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t("vincular-produto") }}
                    </h1>
                </div>
            </div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="produtosSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="columns">
            <div class="column is-6">
                <v-money
                    :id="generateId(1)"
                    ref="valorInput"
                    title="multiplicadorweb"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    :value="multiplicadorweb"
                    @input="multiplicadorwebUpdate"
                    :invalid="isNull(multiplicadorweb)"
                    :max="99999999"
                    precision="5"
                    :precision="precisionNumber"
                    tooltipLabel="informacao-multiplicador"
                    tooltipSize="is-small"
                />
            </div>
            <div class="column is-6">
                <v-money
                    :id="generateId(2)"
                    ref="valorInput"
                    title="multiplicadortrocaweb"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    :value="multiplicadortrocaweb"
                    @input="multiplicadortrocawebUpdate"
                    :invalid="isNull(multiplicadortrocaweb)"
                    :max="99999999"
                    precision="5"
                    :precision="precisionNumber"
                    tooltipSize="is-small"
                />
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-produto"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="produtos"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="produtosSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.idproduto === linha.idproduto"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import ProdutoService from '@/services/vendas/empresa/abas/AssProdutoEmpresaService';

// COMPONENTS


import Message from "@/models/Message";

export default {
    props: {
        idempresa: 0,
    },
    data() {
        return {
            service: new ProdutoService(this.$http, this.$router),
            produtos: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
            ],
            produtosSelecionados: [],
            idproduto: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],
            multiplicadorweb: 1,
            multiplicadortrocaweb: 1,
            precisionNumber: 5,

            isVenda: this.$route.meta.contexto == "vendas",
            isPromotor: this.$route.meta.contexto == "promotor",
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        multiplicadorwebUpdate(value){
            this.multiplicadorweb = value;
        },
        multiplicadortrocawebUpdate(value){
            this.multiplicadortrocaweb = value;
        },

        generateId(numberId){
            return this.$route.name+'-produto-'+numberId;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findProdutosNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idempresa,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.produtos = value;
                this.isEmpty = this.produtos.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        findProdutosNaoAssociados(column, order, page, limit, idempresa, ...params) {   
            if (this.isVenda) {
                return this.service
                .findProdutosNaoAssociadosVendas(column, order, page, limit, idempresa, ...params);
            }else if (this.isPromotor) {
                return this.service
                .findProdutosNaoAssociadosPromotor(column, order, page, limit, idempresa, ...params);
            }else {
                return this.service
                .findProdutosNaoAssociadosAgro(column, order, page, limit, idempresa, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            if (this.isPromotor) {
                return body.content.map(m => {
                    return {
                        idempresa: this.idempresa,
                        idproduto: m.idproproduto,
                        codigo: m.idproprodutoerp,
                        descricao: m.descricao,
                        multiplicador: 1,
                        multiplicadortroca: 1,
                        multiplicadorweb: 1,
                        multiplicadortrocaweb: 1,
                    };
                });
            }else {
                return body.content.map(m => {
                    return {
                        idempresa: this.idempresa,
                        idproduto: m.idproduto,
                        codigo: m.idprodutoerp,
                        descricao: m.descricao,
                        multiplicador: 1,
                        multiplicadortroca: 1,
                        multiplicadorweb: 1,
                        multiplicadortrocaweb: 1,
                    };
                });
            }
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            Object.entries(this.produtosSelecionados).forEach(([key, value]) => {
                value.multiplicadorweb = this.multiplicadorweb;
                value.multiplicadortrocaweb = this.multiplicadortrocaweb;
            })
            this.isLoading = true;

            this.saveProduto()
            .then(value => {
                if (value.content === null) {
                    this.msgs.push(new Message("error", `${value.message}`, true));
                } else {
                    this.$emit('fecharModal', true);
                }
            })
            .catch((e) => {
                this.msgs.push(new Message("alert", 'msg-erro-load', true));
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        saveProduto() {
            if (this.isVenda) return this.service.saveVendas(this.produtosSelecionados);
            else if (this.isPromotor) return this.service.savePromotor(this.produtosSelecionados);
            else return this.service.saveAgro(this.produtosSelecionados);
        },
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
